import { useNavigate } from 'react-router-dom';
import type { VaultItem } from '@heybesafe/shared';
import { HbsListRow } from './hbs/ListRow';
import { Icon } from './hbs/Icon';
import { ContactAvatar } from './ContactAvatar';

interface ContactRowProps {
  item: VaultItem;
  /** Highlights the row for route-based selection. */
  selected?: boolean;
}

/** One contact row in the My Contacts list. Supporting line is the most
 *  identifying secondary detail we have: role, else company, else the first
 *  phone or email. The quick action copies that first phone/email. */
export function ContactRow({ item, selected }: ContactRowProps): JSX.Element {
  const navigate = useNavigate();
  const firstPhone = item.phones?.find((p) => p.value.trim())?.value;
  const firstEmail = item.emails?.find((e) => e.value.trim())?.value;
  const supporting = item.role || item.company || firstPhone || firstEmail || '';

  return (
    <HbsListRow
      id={`contact-row-${item.id}`}
      leading={<ContactAvatar name={item.name} size={34} />}
      title={item.name}
      supporting={supporting}
      selected={selected}
      onClick={() => navigate(`/contacts/${item.id}`)}
      actions={
        <button
          id={`contact-view-${item.id}`}
          type="button"
          aria-label="View"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/contacts/${item.id}`);
          }}
          className="p-1.5 rounded-hbs-sm text-hbs-text-mute hover:text-hbs-text hover:bg-hbs-surface-alt"
        >
          <Icon name="view" size={14} />
        </button>
      }
    />
  );
}
